/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 09.11.2016.
 */

import moment from 'moment';
import ja from 'moment/locale/ja';

moment.updateLocale('jp_JP', {
  calendar: {
    lastDay: '[前日]',
    sameDay: '[同日]',
    nextDay: '[翌日]',
    lastWeek: '[先週] dddd',
    nextWeek: '[翌週] dddd',
    sameElse: '[前]'
  }
});

const jp_JP = {
  yes: 'はい',
  no: 'いいえ',
  no_thanks: 'いいえˆ',
  loading: '読込中...',
  global_error: '予期せぬ問題発生、再度お試し下さい。',
  email: 'Eメール',
  password: 'パスワード',
  close: '閉じる',
  favorites: 'お気に入り',
  search: '検索',
  related: '関連',
  tv: 'テレビチャンネル',
  movies: '映画',
  tvseries: 'テレビシリーズ',
  on_now: '電子番組表',
  cartoons: 'アニメ',
  purchases: '購入',
  premiere: 'プレミア',
  my_services: {
    my_services: 'サービス中',
    my_rents: 'レント中',
    my_subscriptions: '購読中',
    subscriptions: '購読',
    rents: 'レント'
  },
  page: {
    home: 'ホーム',
    epg: '電子番組表',
    favorites: 'お気に入り',
    notifications: '通知',
    records: '録画',
    purchases: '購入',
    related: '関連',
    search: '検索',
    collection: 'コレクション'
  },
  error: {
    invalid_credentials: '入力情報に誤りがございます。',
    invalid_credentials_description: ' ',
    blocked_subscription: '今月のクレジット課金出来ないため一時的に購読が停止しています、カスタマーサポート（info@dya.tv 212-967-6848）まで新しカード情報をお知らせください。',
    'invalid credentials': '古いパスワードが違います。',
    'passwords mismatch': 'パスワードは同じものでお願いします。',
    'username field empty': 'Eメールが空欄です。',
    'already exist': '既にこのEメールで登録済です。その他のEメールアドレスをご使用下さい。',
    'password field empty': 'パスワードが空欄です。',
    'password too short': 'パスワードが短すぎます。パスワードは6桁以上の組み合わせで数字、アルファベット、特殊記号が使用可能です。',
    'invalid password reset code': 'パスワード再設定コードが違います。',
    'invalid ack': 'コンファメーションコードが違います。',
    'invalid pin': 'ピンコードが違います。'
  },
  registration: {
    texts: {
      button: 'アカウント作成',
      title: 'DYA.TV登録はここから',
      description: '右の鉛筆アイコンをクリックした後、Eメール、パスワード、氏名をご登録下さい。'
    }
  },
  login: {
    login: 'ログイン',
    login_example: 'youremail@domain.com',
    lost_your_password: 'パスワドを忘れた場合はこちらから',
    logout: 'ログアウト',
    log_in: 'ログイン中'
  },
  forgot_password: {
    login: 'ログイン',
    login_example: 'youremail@domain.com',
    lost_your_password: 'パスワドを忘れた場合はこちらから',
    forgot_password: 'パスワドを忘れた場合はこちらから',
    send: "送信",
    recovery_password: "パスワード再生",
    empty_field: "フィールドが空欄です。",
    wrong_email: "Eメールアドレスが違います。",
    reset_password_success_message: "ご登録のEメールアドレスへパスワードをリセットするメールを送信しました。",
    reset_password_error_message: "ご登録のEメールアドレスへパスワードをリセットするメールを送信しました。",
  },
  profile: {
    movie: {
      bundle: 'バンドル',
      min: 'min',
      fav_add: 'お気に入りへ追加',
      fav_remove: 'お気に入りから削除',
      trailer: '予告',
      youtube_trailer: 'ユーチューブ予告',
      multiscreen: '別画面で見る',
      related: '関連',
      share: 'シェア',
      select_screen: 'スクリーン選択'
    },
    tvSeries: {
      bundle: 'バンドル',
      min: 'min',
      fav_add: 'お気に入りへ追加',
      fav_remove: 'お気に入りから削除',
      trailer: '予告',
      multiscreen: '別画面で見る',
      related: '関連',
      share: 'シェア',
      select_screen: 'スクリーン選択',
      seasons: 'シーズン',
      episodes: 'エピソード',
      season_short: 'S', //S01E12
      episode_short: 'E', //S01E12
    },
    channel: {
      calendar: {
        before: '以前',
        previously: '以前',
        now: '放送中',
        after: '次',
        hereafter: '以後',
        yesterday: '昨日',
        yesterday_at: '昨日',
        today: '本日',
        today_at: '本日',
        tomorrow: '明日',
        tomorrow_at: '明日',
        last: '最後'
      },
      epg: '電子番組表',
      bundle: 'バンドル',
      min: 'min',
      fav_add: 'お気に入りへ追加',
      fav_remove: 'お気に入りから削除',
      record_add: '録画へ追加',
      record_remove: '録画から削除',
      schedule_remove: '予約取消',
      multiscreen: '別画面で見る',
      share: 'シェア',
      select_screen: 'スクリーン選択'
    },
    subscription: {
      subscription: '購読',
      included: '含む',
      expires: '失効',
      bought: '購入',
      owned: '購入済',
      subscription_period_end: '購読終了日',
      subscription_period_start: '購読開始日',
      subscription_states: {
        active: '購読中',
        trialing: 'トライアル中',
        unpaid: '未払',
        '_': '不明'
      },
      cancel: '解約',
      canceled: '解約済',
      first_payment: '初回支払',
      details: '詳細',
      status: 'ステータス',
      are_you_sure: '宜しいですか？',
      cancel_desc: '購読の解約は',
      re_subscribe: '再購読は現在の購読期間終了後のみ可能です。',
      yes: 'はい',
      no: 'いいえ'
    },
    packages: {
      included: '含む',
      expires: '失効',
      bought: '購入',
      owned: '購入済'
    },
    epg_event: {
      remind_me: '通知',
      not_remind: '非通知',
      record_add: '録画追加',
      record_remove: '録画削除',
      schedule_remove: '予約解除'
    },
    notification: {
      remind_me: '通知',
      not_remind: '非通知',
    },
    npvr: {
      record_add: '録画追加',
      record_remove: '録画削除',
      schedule_remove: '予約解除'
    },
    ratings: {
      rating_delimiter: '/'
    },
    persons: {
      operator: 'オペレーター',
      assembly: 'アッセンブリー',
      actor: 'アクター',
      director: 'ディレクター',
      scenario: 'シナリオ',
      composer: 'コンポーザー',
      presenter: 'プレゼンター',
      music_director: 'ミュージックディレクター',
      playback_singers: 'プレイバックシンガー',
      _: 'その他'
    },
    offers: {
      type: {
        'free': 'フリー',
        'transactional-own': '購入',
        'transactional-rent': '借りる',
        'subscription': '購読',
        'transactional-own-bundle': 'バンドルを購入',
        'transactional-rent-bundle': 'バンドルを借りる',
        'subscription-bundle': 'バンドルを購読',
        '_': 'その他'
      },
      pay_as_you_go: '購入オファー',
      select_bundle: 'バンドルを選択',
      or: 'もしくは',
      free_trial: 'フリートライアル',
      free_trial_description: 'フリートライアル終了後に課金開始',
      unit: {
        hour: '時間',
        day: '日間',
        week: '週間',
        month: 'ケ月間',
        year: '年間',
      }
    }
  },
  player: {
    no_signal: '受信不可...',
    reload: '読込中...',
    youtube_connection_error: 'ユーチューブの読込に失敗...'
  },
  more_menu_items: '更に',
  empty_section: '該当結果無し',
  empty_result: '該当結果無し',
  epg: {
    no_data: 'データ無し',
    now: '現在',
    today: '本日'
  },
  npvr: {
    filters: {
      status: '録画状況順に並べる',
      date: '日付順に並べる',
      alphabet: 'タイトル順に並べる',
      channel: '番組順に並べる'
    },
    status: {
      pending: '未録画',
      scheduled: '予約済',
      recording: '録画中',
      finished: '録画済',
      failed: '録画失敗',
      cancelled: '録画解除'
    },
    usage: '使用数',
    limit_desc: '現在の使用数と使用可能数。',
    limit_desc_warning: '間も無く使用可能数に達します。',
    limit_desc_reached: '使用可能数に達したのでいずれかの録画済ファイルを削除して下さい。'
  },
  genres: 'ジャンル',
  messages: {
    pin: {
      title: 'ピンコード入力',
      ok: 'OK',
      cancel: 'キャンセル'
    },
    notification: {
      title: '通知機能',
      on_channel: '通知',
      is_switch_show_right_now: '5分後に開始、今すぐ切り替えますか？'
    },
    share_request: {
      title: 'シェア',
      vod: 'ビデオ',
      live: 'チャンネル',
      you_have_received: '受信しました',
      sharing_notification: '今すぐ確認しますか？'
    },
    bookmark: {
      title: 'ブックマーク',
      continue_from: '継続',
      start_over: '最初から'
    }
  },
  settings: {
    settings: '設定',
    tabs: {
      login: {
        title: 'ログイン',
        email: 'Eメール',
        password: 'パスワード',
        sign_in: 'ログイン',
        error: 'エラー',
        success: 'Welcome back dear customer!'
      },
      registration: {
        title: '登録',
        email: 'Eメール',
        password: 'パスワード',
        password2: 'パスワード再入力',
        first_name: '名',
        last_name: '姓',
        sign_up: '登録',
        success: 'ご登録ありがとうございます!',
        need_confirmation: 'ご登録のEメールアドレスへアクティベーションのメールを発送しましたのでご確認下さい。',
      },
      registration_confirm: {
        success: 'ご登録ありがとうございます!　現在、ご登録のEメールアドレスとバスワードが使用可能です。'
      },
      language: {
        title: '言語',
        select_language: '言語選択:'
      },
      parental_control: {
        title: 'ペアレンタルコントロール',
        description: 'ペアレンタルコントロール開始',
        on: 'On',
        off: 'Off'
      },
      change_password: {
        title: 'パスワード変更',
        save: '保存',
        old_password: '古いパスワード',
        new_password: '新しいバスワードを入力',
        new_password2: 'パスワードを確認',
        success: 'パスワード更新完了'
      },
      reset_password: {
        title: 'パスワード再設定',
        save: '保存',
        enter_new_password: '新しいバスワードを入力',
        ack: '確認コード',
        password: '新パスワード',
        success: 'パスワード更新完了'
      },
    },
  },
  toast: {
    type: {
      record: '録画',
      favorite: 'お気に入り',
      notification: '通知',
      purchase: '購入',
      service: 'サービス',
      cookies: 'クッキー',
      adblock: '広告ブロック'
    },
    operation: {
      record_add_success: '予約設定完了',
      record_add_fail: '予約設定失敗',
      record_remove_success: '予約解除完了',
      record_remove_fail: '予約解除失敗',
      favorite_add_success: 'お気に入り追加完了',
      favorite_add_fail: 'お気に入り追加失敗',
      favorite_remove_success: 'お気に入り解除完了',
      favorite_remove_fail: 'お気に入り解除失敗',
      notification_add_success: '通知設定完了',
      notification_add_fail: '通知設定失敗',
      notification_remove_success: '通知解除完了',
      notification_remove_fail: '通知解除失敗',
      purchase_add_success: '購読設定完了',
      purchase_add_fail: '購読設定失敗',
      purchase_remove_success: '購読解除完了',
      purchase_remove_fail: '購読解除失敗',
      service_unstable_connection: '配信サーバーへの接続が不安定です。',
      enable_cookies: 'クッキーを可能にして下さい。',
      disable_adblock: '広告ブロックを停止して下さい。' +
      '広告ブロックのホワイトリストへ追加して下さい。'
    }
  }
};

export default jp_JP;



// WEBPACK FOOTER //
// ./src/locales/dics/jp_JP.js